import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import App from './App';
import { initAnalytics } from './utils/Analytics';
import './fonts/outfit.css';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
// Loaded after Bootstrap on purpose: it puts back the Bootstrap 4 defaults
// this theme depends on. See sass/_bootstrap-compat.scss.
import './bootstrap-compat.scss';
// Last of all, so its media queries win: the phone and tablet layout.
// See sass/_responsive.scss.
import './responsive.scss';
import './theme.scss';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({ dsn: 'https://acfc4de055a540f2b0bfcee5d8085384@sentry.io/1835621' });
}

// Off unless the server has a Google Analytics ID. See utils/Analytics.ts.
initAnalytics();

createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
